// extracted by mini-css-extract-plugin
export default {"root":"AppLayoutSkeleton_root__1rhwj","header":"AppLayoutSkeleton_header__-n6fM","content":"AppLayoutSkeleton_content__uLtz1","layout":"AppLayoutSkeleton_layout__KOyVA"};